import {
    BrowserRouter,
    Routes,
    Route,
  } from "react-router-dom";
  import Home from '../pages/Home'
  import Projects from '../pages/Projects'
  import Resume from '../pages/Resume'
  import Contact from '../pages/Contact'
  
 const Routing = ()=>{
    return(
        <BrowserRouter>
          <Routes>
              <Route index element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/contact" element={<Contact />} />
          </Routes>
        </BrowserRouter>
      )
 }

 export default Routing;